/** Distinct tab group colors (cycle + filter). */
export const TAB_COLOR_IDS = [
  "red",
  "orange",
  "amber",
  "green",
  "teal",
  "blue",
  "violet",
  "magenta",
] as const;

export type TabColorId = (typeof TAB_COLOR_IDS)[number];

/** null = no color; cycle order: none → first color → … → last → none. */
export function nextTabColor(current: TabColorId | null): TabColorId | null {
  if (current === null) return TAB_COLOR_IDS[0]!;
  const i = TAB_COLOR_IDS.indexOf(current);
  if (i < 0) return TAB_COLOR_IDS[0]!;
  if (i >= TAB_COLOR_IDS.length - 1) return null;
  return TAB_COLOR_IDS[i + 1]!;
}
